var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 23,
    rx: 3.5,
    stroke: "black",
    strokeOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95025 15.7582H7.89051L6.34596 9.69237C6.27264 9.41334 6.11698 9.16666 5.88801 9.0504C5.31659 8.75822 4.68691 8.5257 4 8.40843V8.17489H7.31808C7.77602 8.17489 8.11948 8.5257 8.17672 8.93312L8.97813 13.3086L11.0369 8.17489H13.0394L9.95025 15.7582ZM14.1842 15.7582H12.239L13.8408 8.17489H15.786L14.1842 15.7582ZM18.3027 10.2757C18.3599 9.86727 18.7034 9.63374 19.1041 9.63374C19.7338 9.5751 20.4197 9.69237 20.9921 9.98353L21.3356 8.3508C20.7631 8.11727 20.1335 7.99999 19.562 7.99999C17.674 7.99999 16.3002 9.0504 16.3002 10.5082C16.3002 11.6173 17.2733 12.1996 17.9602 12.5504C18.7034 12.9002 18.9896 13.1337 18.9324 13.4835C18.9324 14.0082 18.3599 14.2418 17.7885 14.2418C17.1016 14.2418 16.4147 14.0669 15.786 13.7747L15.4426 15.4084C16.1295 15.6996 16.8726 15.8169 17.5595 15.8169C19.6765 15.8745 20.9921 14.8251 20.9921 13.25C20.9921 11.2665 18.3027 11.1502 18.3027 10.2757ZM27.8 15.7582L26.2554 8.17489H24.5964C24.2529 8.17489 23.9095 8.40843 23.795 8.75822L20.9349 15.7582H22.9374L23.3371 14.6502H25.7975L26.0265 15.7582H27.8ZM24.8826 10.2171L25.454 13.0751H23.8523L24.8826 10.2171Z",
    fill: "#494E55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.146e9c73596a4e22ea35eb1c1e0f3d65.svg";
export { ForwardRef as ReactComponent };